import bnLcvRouteLanding from "../../../../core/src/locales/bn/lcvRouteLanding.json";
import enLcvRouteLanding from "../../../../core/src/locales/en/lcvRouteLanding.json";
import guLcvRouteLanding from "../../../../core/src/locales/gu/lcvRouteLanding.json";
import hiLcvRouteLanding from "../../../../core/src/locales/hi/lcvRouteLanding.json";
import knLcvRouteLanding from "../../../../core/src/locales/kn/lcvRouteLanding.json";
import mrLcvRouteLanding from "../../../../core/src/locales/mr/lcvRouteLanding.json";
import taLcvRouteLanding from "../../../../core/src/locales/ta/lcvRouteLanding.json";
import teLcvRouteLanding from "../../../../core/src/locales/te/lcvRouteLanding.json";

const LCV_ROUTE_SLUGS_BY_LOCALE: Record<string, Set<string>> = {
    bn: new Set(Object.keys(bnLcvRouteLanding.routes ?? {})),
    en: new Set(Object.keys(enLcvRouteLanding.routes ?? {})),
    gu: new Set(Object.keys(guLcvRouteLanding.routes ?? {})),
    hi: new Set(Object.keys(hiLcvRouteLanding.routes ?? {})),
    kn: new Set(Object.keys(knLcvRouteLanding.routes ?? {})),
    mr: new Set(Object.keys(mrLcvRouteLanding.routes ?? {})),
    ta: new Set(Object.keys(taLcvRouteLanding.routes ?? {})),
    te: new Set(Object.keys(teLcvRouteLanding.routes ?? {}))
};

export function getVerifiedHreflangLocales(slug: string, hreflangLocales: string[]) {
    const verifiedLocales = hreflangLocales.filter((locale) => LCV_ROUTE_SLUGS_BY_LOCALE[locale]?.has(slug));

    if (verifiedLocales.length > 0) {
        return verifiedLocales;
    }

    return LCV_ROUTE_SLUGS_BY_LOCALE.en?.has(slug) ? ["en"] : ["en"];
}
